import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AddRedeemBrand from "../../../components/SuperAdmin/RedeemBrand/AddRedeemBrand";

export default withRouter(connect()(AddRedeemBrand));
